export enum ColumnType {
    Text,
    Numeric,
    Date,
    List,
    Boolean,
    WorklowStep,
    MultipleList,
    DateAndTime,
    Link,
    AutocompletionByApi,
}
